import { useEffect, useRef } from 'react'
import { buildMarkerContent, markerCacheKey, MarkerContentOptions } from '../../../utils/liveMap/buildMarkerContent'

/**
 * Renders the exact same logo + count-badge token used by the map markers
 * (via the shared buildMarkerContent renderer), so the spotlight ticker cards
 * match the markers and the mobile app. Pulse is omitted for cards.
 */
const MarkerToken = (props: MarkerContentOptions) => {
  const ref = useRef<HTMLSpanElement>(null)
  const key = markerCacheKey(props)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.innerHTML = ''
    el.appendChild(buildMarkerContent(props))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return <span ref={ref} className="venue-token" />
}

export default MarkerToken
